import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
    class: "flex-column",
    style: { "width": "1920px" }
};
var _hoisted_2 = { class: "layout-header pr-20" };
var _hoisted_3 = { class: "d-flex-center" };
var _hoisted_4 = ["src"];
var _hoisted_5 = {
    class: "fs-24 ml-3",
    style: {}
};
var _hoisted_6 = { class: "d-flex" };
var _hoisted_7 = { class: "nav-list" };
var _hoisted_8 = { class: "nav-item" };
var _hoisted_9 = { class: "nav-item" };
var _hoisted_10 = { class: "nav-item" };
var _hoisted_11 = { class: "d-flex-between-center color-white pl-24 pr-40" };
var _hoisted_12 = { class: "d-flex-center" };
var _hoisted_13 = { style: { "margin-left": "10px" } };
var _hoisted_14 = ["src"];
var _hoisted_15 = { style: { "margin-left": "35px", "width": "115px" } };
var _hoisted_16 = {
    class: "text-glow fs-24 fw-7",
    style: { "letter-spacing": "0.25em" }
};
var _hoisted_17 = {
    class: "fs-12 d-flex-between-center",
    style: { "width": "115px" }
};
var _hoisted_18 = {
    class: "overflow-auto info-screen-container",
    style: { "--fill-height": "calc(var(--adaptive-height) - 80px)", "height": "var(--fill-height)", "box-sizing": "border-box" }
};
import AdaptiveBox from '@/components/adaptive-box/AdaptiveBox.vue';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { ElMessage, ElNotification } from 'element-plus';
import router from '@/router';
import screenfull from 'screenfull';
import { useRoute } from 'vue-router';
import { ArrowDown, } from '@element-plus/icons-vue';
import { DateFormat, moment } from '@utils/moment';
import settings from '@/settings';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LayoutScreen',
    setup: function (__props) {
        var route = useRoute();
        var win = window;
        var store = useStore();
        // vuex的id信息
        var user = ref(store.getters['app/projectInfo']);
        onMounted(function () {
            document.body.classList.add('layout-screen-container');
            // document.body.classList.remove('layout-screen-container')
            nowTime();
            if (screenfull.isEnabled) {
                screenfull.on('change', changeEvent);
            }
        });
        var activeIndex = ref('1');
        // 当前时间
        var datetime = ref({});
        var timer = null;
        var nowTime = function () {
            timer = setInterval(function () {
                datetime.value = {
                    date: moment().format(DateFormat.date),
                    time: moment().format(DateFormat.time),
                    week: moment().format('dddd'),
                };
            }, 500);
        };
        var checked = ref('');
        var handleCheck = function (v) {
            console.log(v, '000');
            checked.value = v;
        };
        // TODO 厂区
        var currentFactory = ref(0);
        // 当前选中菜单
        var activeMenu = computed(function () {
            var _a;
            return ((_a = route.meta) === null || _a === void 0 ? void 0 : _a.activeMenu) || route.name;
        });
        var activeMenuItem = computed(function () { return route.name; });
        // user信息
        var userInfo = computed(function () { return store.getters['app/userInfo']; });
        // TODO 全屏
        var isFullscreen = ref(false);
        var screenToggle = function () {
            if (!screenfull.isEnabled) {
                ElMessage.warning('您的浏览器不支持全屏功能');
                return false;
            }
            screenfull.toggle();
        };
        var changeEvent = function () {
            isFullscreen.value = screenfull.isFullscreen;
        };
        onUnmounted(function () {
            document.body.classList.remove('layout-screen-container');
            // 删除监听器
            if (screenfull.isEnabled) {
                screenfull.off('change', changeEvent);
            }
            timer && clearInterval(timer);
        });
        // TODO 登出
        function logout() {
            router.replace({ name: 'HomeView' });
        }
        // ElNotification({
        //   // icon: Search,
        //   type: 'warning',
        //   title: 'qwewqewqs',
        //   zIndex: 999,
        //   showClose: true,
        //   duration: 50000,
        //   // dangerouslyUseHTMLString: true,
        //   message: 'dsadas'
        // })
        console.log(userInfo.value.id);
        // 和服务端建立长连接 接收报警信息
        var wsUrl = ref("".concat(settings.WEBSOCKET, "/").concat(userInfo.value.id));
        var ws = new WebSocket(wsUrl.value);
        ws.onopen = function (evt) {
            console.log('连接成功 webSocket');
            // ws.send('给我消息')
        };
        // 如果消息不是undefined就调用
        ws.onmessage = function (e) {
            var abc = e.data;
            var aaa = JSON.parse(abc);
            console.log(aaa);
            // 报警弹窗
            if (aaa.value !== undefined) {
                ElNotification({
                    type: 'warning',
                    title: "".concat(aaa.deviceName),
                    zIndex: 999,
                    showClose: true,
                    duration: 5000,
                    message: "".concat(aaa.alarmRemarks),
                });
            }
        };
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            var _component_el_icon = _resolveComponent("el-icon");
            var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            var _component_el_dropdown = _resolveComponent("el-dropdown");
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(AdaptiveBox, {
                mode: "full-height",
                reference: _unref(win),
                observeNodeUpdate: true
            }, {
                default: _withCtx(function () {
                    var _a, _b, _c;
                    return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("img", {
                                        class: "ml-24",
                                        src: user.value.logo,
                                        alt: "",
                                        style: { "width": "60px", "height": "60px" }
                                    }, null, 8, _hoisted_4),
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(user.value.title), 1)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_component_router_link, { to: "/monitor-screen/system-description" }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["nav-item", { active: _unref(activeMenu) === 'SystemDescription' }])
                                                }, "系统概述", 2)
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_router_link, { to: "/monitor-screen/gis" }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["nav-item", { active: _unref(activeMenu) === 'GisView' }])
                                                }, "GIS地图", 2)
                                            ]; }),
                                            _: 1
                                        }),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["nav-item", { active: _unref(activeMenu) === 'RealTimeData' || _unref(activeMenu) === 'RealTimeDataDetail' }]),
                                            style: { "margin-left": "20px" }
                                        }, [
                                            _createVNode(_component_el_dropdown, { trigger: "hover" }, {
                                                dropdown: _withCtx(function () { return [
                                                    _createVNode(_component_el_dropdown_menu, { class: "fw-7" }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(_component_el_dropdown_item, {
                                                                style: _normalizeStyle({ 'color': _unref(activeMenuItem) === 'EquipmentOverview' ? '#5478c7' : '' }),
                                                                onClick: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).push({ name: 'EquipmentOverview' })); })
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode("设备总览 ")
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"]),
                                                            _createVNode(_component_el_dropdown_item, {
                                                                divided: "",
                                                                style: _normalizeStyle({ 'color': _unref(activeMenuItem) === 'RealTimeVariableModeQuery' ? '#5478c7' : '' }),
                                                                onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(router).push({ name: 'RealTimeVariableModeQuery' })); })
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode("变量方式查询 ")
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"]),
                                                            _createVNode(_component_el_dropdown_item, {
                                                                divided: "",
                                                                style: _normalizeStyle({ 'color': _unref(activeMenuItem) === 'RealTimeStationModeQuery' ? '#5478c7' : '' }),
                                                                onClick: _cache[2] || (_cache[2] = function ($event) { return (_unref(router).push({ name: 'RealTimeStationModeQuery' })); })
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode("测站方式查询 ")
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"])
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                default: _withCtx(function () { return [
                                                    _createElementVNode("span", _hoisted_8, [
                                                        _createTextVNode("实时数据"),
                                                        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                                            default: _withCtx(function () { return [
                                                                _createVNode(_unref(ArrowDown))
                                                            ]; }),
                                                            _: 1
                                                        })
                                                    ])
                                                ]; }),
                                                _: 1
                                            })
                                        ], 2),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["nav-item", { active: _unref(activeMenu) === 'HistoryData' }]),
                                            style: { "margin-left": "0px" }
                                        }, [
                                            _createVNode(_component_el_dropdown, { trigger: "hover" }, {
                                                dropdown: _withCtx(function () { return [
                                                    _createVNode(_component_el_dropdown_menu, { class: "fw-7" }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(_component_el_dropdown_item, {
                                                                style: _normalizeStyle({ 'color': _unref(activeMenuItem) === 'HistoryVariableModeQuery' ? '#5478c7' : '' }),
                                                                onClick: _cache[3] || (_cache[3] = function ($event) { return (_unref(router).push({ name: 'HistoryVariableModeQuery' })); })
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode("变量方式查询 ")
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"]),
                                                            _createVNode(_component_el_dropdown_item, {
                                                                divided: "",
                                                                style: _normalizeStyle({ 'color': _unref(activeMenuItem) === 'HistoryStationModeQuery' ? '#5478c7' : '' }),
                                                                onClick: _cache[4] || (_cache[4] = function ($event) { return (_unref(router).push({ name: 'HistoryStationModeQuery' })); })
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode("测站方式查询 ")
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"])
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                default: _withCtx(function () { return [
                                                    _createElementVNode("span", _hoisted_9, [
                                                        _createTextVNode("历史数据"),
                                                        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                                            default: _withCtx(function () { return [
                                                                _createVNode(_unref(ArrowDown))
                                                            ]; }),
                                                            _: 1
                                                        })
                                                    ])
                                                ]; }),
                                                _: 1
                                            })
                                        ], 2),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["nav-item", { active: _unref(activeMenu) === 'ReportData' }]),
                                            style: { "margin-left": "0px" }
                                        }, [
                                            _createVNode(_component_el_dropdown, { trigger: "hover" }, {
                                                dropdown: _withCtx(function () { return [
                                                    _createVNode(_component_el_dropdown_menu, { class: "fw-7" }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(_component_el_dropdown_item, {
                                                                style: _normalizeStyle({ 'color': _unref(activeMenuItem) === 'DayReportData' ? '#5478c7' : '' }),
                                                                onClick: _cache[5] || (_cache[5] = function ($event) { return (_unref(router).push({ name: 'DayReportData' })); })
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode("日报表 ")
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"]),
                                                            _createVNode(_component_el_dropdown_item, {
                                                                divided: "",
                                                                style: _normalizeStyle({ 'color': _unref(activeMenuItem) === 'MonthReportData' ? '#5478c7' : '' }),
                                                                onClick: _cache[6] || (_cache[6] = function ($event) { return (_unref(router).push({ name: 'MonthReportData' })); })
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode("月报表 ")
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"]),
                                                            _createVNode(_component_el_dropdown_item, {
                                                                divided: "",
                                                                style: _normalizeStyle({ 'color': _unref(activeMenuItem) === 'YearReportData' ? '#5478c7' : '' }),
                                                                onClick: _cache[7] || (_cache[7] = function ($event) { return (_unref(router).push({ name: 'YearReportData' })); })
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode("年报表 ")
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"])
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                default: _withCtx(function () { return [
                                                    _createElementVNode("span", _hoisted_10, [
                                                        _createTextVNode("数据报表"),
                                                        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                                            default: _withCtx(function () { return [
                                                                _createVNode(_unref(ArrowDown))
                                                            ]; }),
                                                            _: 1
                                                        })
                                                    ])
                                                ]; }),
                                                _: 1
                                            })
                                        ], 2),
                                        _createVNode(_component_router_link, {
                                            to: "/monitor-screen/alarm-record",
                                            style: { "margin-left": "0px" }
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["nav-item", { active: _unref(activeMenu) === 'AlarmRecord' }])
                                                }, "报警记录", 2)
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_router_link, {
                                            to: "/monitor-screen/camera-view",
                                            style: { "margin-left": "0px" }
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["nav-item", { active: _unref(activeMenu) === 'CameraView' }])
                                                }, "摄像头", 2)
                                            ]; }),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", {
                                                class: "d-flex-center cursor-pointer",
                                                onClick: screenToggle,
                                                style: { "width": "75px" }
                                            }, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass(["iconfont", [isFullscreen.value ? 'ic_shousuo' : 'ic_quanping']])
                                                }, null, 2),
                                                _createElementVNode("span", _hoisted_13, _toDisplayString(isFullscreen.value ? '收起' : '全屏'), 1)
                                            ]),
                                            _createElementVNode("div", {
                                                class: "cursor-pointer",
                                                style: { "margin-left": "22px" },
                                                onClick: logout
                                            }, [
                                                _createElementVNode("img", {
                                                    src: require('./images/backBtn.png')
                                                }, null, 8, _hoisted_14)
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, _toDisplayString((_a = datetime.value) === null || _a === void 0 ? void 0 : _a.time), 1),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", null, _toDisplayString((_b = datetime.value) === null || _b === void 0 ? void 0 : _b.date), 1),
                                                    _createElementVNode("div", null, _toDisplayString((_c = datetime.value) === null || _c === void 0 ? void 0 : _c.week), 1)
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_router_view)
                        ])
                    ];
                }),
                _: 1
            }, 8, ["reference"]));
        };
    }
});
